import { render, staticRenderFns } from "./HighPotentialNewCustomer.vue?vue&type=template&id=17b950f6"
import script from "./HighPotentialNewCustomer.vue?vue&type=script&lang=js"
export * from "./HighPotentialNewCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports